import { useSelector, useDispatch } from 'react-redux';

import { RadioButtonGroup } from '../../components/RadioButtonGroup';
import { RootState } from '../../redux/store';
import { changeAppFontSize } from '../../redux/appConfigSlice';
import { FontSizeType } from '../../interface/interface';
import { options } from './options';
import classes from './FontSelection.module.css';
import { useState } from 'react';
import { ErrorCard } from '../../components/ErrorCard';
import errorCodeDescription from '../../components/ErrorCard/errorProperties';

// Font selection screen component with radio buttons to change font size.
const FontSelection = () => {
    const [errorCode, setErrorCode] = useState<string>('');
    const fontSize = useSelector((state: RootState) => state.appConfigSlice.appFontSize);
    const dispatch = useDispatch();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            dispatch(changeAppFontSize(e.target.value as FontSizeType));
        } catch (err) {
            setErrorCode("V201"); 
            console.error(errorCodeDescription[errorCode]);
        }
    };

    if (errorCode) {
        return <ErrorCard errorCode={errorCode} />;
    }


    return (
        <>
            <RadioButtonGroup
                id="fontsize"
                name="fontSize"
                onChange={handleChange}
                options={options}
                value={fontSize}
                className={classes.container}
            />
            {errorCode && <ErrorCard errorCode={errorCode} />}
        </>
    );
};

export default FontSelection;
